import axiosInstance from "../../lib/axios";

export async function Getmenudata(payload) {
    try {
      return await axiosInstance.post("MstModule/RetriveMstModule", payload);
    } catch (error) {
      return error;
    }
  }


  export async function GetUserdata(payload) {
    try {
      return await axiosInstance.post("UserMst/GetMakeDropDown", payload);
    } catch (error) {
      return error;
    }
  }
//insert and Update data api 
  export async function dataInsertonSubmit(payload) {
    try {
      return await axiosInstance.post("MstUserPrev/ManageMstUserPrev", payload);
    } catch (error) {
      return error;
    }
  }
// retrivew data api 
  export async function dataRetrivewApi(payload) {
    try {
      return await axiosInstance.post("MstUserPrev/GetMstUserPrevDashBoard", payload);
    } catch (error) {
      return error;
    }
  }

 
export async function updateWishlistApi(payload) {
  try {
    return await axiosInstance.post("MstUserPrev/UpdateMstUserPrevWishlist", payload);
  } catch (error) {
    return error;
  }
}